import React from "react";
import { Chip, Tooltip } from "@mui/material";
import { useCaseListStore } from "../hooks/useCaseListStore";

export default function Chips({ bulkUpdateFilters }) {
  const filterState = useCaseListStore((state) => state.filterUI);
  const setChipDeactive = useCaseListStore((state) => state.setChipDeactive);
  const setSearchValue = useCaseListStore((state) => state.setSearchValue);

  const getChipLabel = (val) => {
    let typeCheck = Object.prototype.toString;

    if (!val) {
      return "";
    }
    let pArr = val;

    if (typeCheck.call(val) === "[object Object]") {
      return pArr.join(", ");
    }
    let deliminator = pArr === "" ? "" : ": ";
    return deliminator + pArr;
  };

  const label = (chip) => chip.title + getChipLabel(chip.activeChip?.label);
  const customChip = (key, chip) => {
    const chipLabel = label(chip);
    return (
      <Tooltip
        title={chipLabel}
        arrow
        key={key}
        slotProps={{
          popper: {
            modifiers: [
              {
                name: "offset",
                options: {
                  offset: [0, -8],
                },
              },
            ],
          },
        }}
      >
        <Chip
          className={`max-w-[500px] px-2 m-1 text-wrap text-center rounded-lg shadow-inner ${
            chip?.activeChip?.isActive ? "" : "hidden"
          }`}
          color="primary"
          key={key}
          onDelete={() => {
            bulkUpdateFilters([
              ...(chip.filterType === "DateRange" ? [
                [chip.fieldName + "__gte", []],
                [chip.fieldName + "__lte", []],
              ] : [[chip.fieldName, []]]),
            ]);
            setChipDeactive(key, null);
            if (chip.fieldName === "search") {
              setSearchValue(chip.fieldName, "");
            }

            localStorage.removeItem(chip.fieldName);
          }}
          label={chipLabel}
        />
      </Tooltip>
    );
  };

  return (
    <div>
      {filterState && Object.keys(filterState).length > 0
        ? Object.keys(filterState).map((filt) =>
            customChip(filt, filterState[filt])
          )
        : ""}
    </div>
  );
}